import { useCallback } from 'react';
import { CloseOutlined, MenuOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { useIntl } from 'react-intl';

import { toggleCollapsedSideNav } from 'appRedux/actions/Setting';

import styles from './style.module.less';

const Topbar = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const { navCollapsed } = useSelector(({ common }) => common);

  const handleToggleNav = useCallback(() => {
    dispatch(toggleCollapsedSideNav(!navCollapsed));
  }, [dispatch, navCollapsed]);

  const menuLabel = intl.formatMessage({
    id: navCollapsed ? 'topbar.mobile.closeNavigation' : 'topbar.mobile.openNavigation',
  });

  return (
    <header className={styles.mobileHeader}>
      <button
        type="button"
        data-mobile-nav-toggle
        className={styles.menuButton}
        onClick={handleToggleNav}
        aria-label={menuLabel}
        aria-expanded={navCollapsed}
      >
        {navCollapsed ? <CloseOutlined aria-hidden /> : <MenuOutlined aria-hidden />}
      </button>

      <Link
        to="/"
        className={styles.logoLink}
        aria-label={intl.formatMessage({ id: 'general.home' })}
      >
        <img src="/logo_operonda.png" alt="" width={40} height={25} className={styles.logo} />
      </Link>

      <span className={styles.headerSpacer} aria-hidden />
    </header>
  );
};

export default Topbar;
